import React from 'react'
import BrandSlider from '../../Slider/BrandSlider'

export default function BrandScrollSection({data, sectionTitle, sectionTitleUp}) {
  return (
    <BrandSlider sectionTitle={sectionTitle} sectionTitleUp={sectionTitleUp} data={data} />
  )
}
